import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b94b1d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header-text" }, "教科", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurriculumEditTableCell = _resolveComponent("CurriculumEditTableCell")!
  const _component_AddButtonSmall = _resolveComponent("AddButtonSmall")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["curriculum-edit-table-row-section-container", { editing: _ctx.editing }]),
    style: _normalizeStyle(_ctx.styles)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.evalTypeJapanese), 1),
        _hoisted_4
      ]),
      _createVNode(_TransitionGroup, {
        class: "cells",
        name: "cells-group",
        tag: "ul"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.curriculums, (c) => {
            return (_openBlock(), _createBlock(_component_CurriculumEditTableCell, {
              key: `${c.evalType}:${c.clientSideId}`,
              class: "cell",
              name: c.name.value,
              editing: _ctx.editing,
              deleted: c.deleted,
              "on-input-name": 
            (value) => _ctx.updateName(c.evalType, c.clientSideId, value)
          ,
              move: (up) => _ctx.moveCurriculum(c.evalType, c.clientSideId, up),
              delete: () => _ctx.deleteCurriculum(c.evalType, c.clientSideId)
            }, null, 8, ["name", "editing", "deleted", "on-input-name", "move", "delete"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["add-button-area", { editing: _ctx.editing }])
    }, [
      (_ctx.editing)
        ? (_openBlock(), _createBlock(_component_AddButtonSmall, {
            key: 0,
            class: "add-button",
            "aria-label": "Add",
            "on-click": _ctx.addCurriculum
          }, null, 8, ["on-click"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 6))
}